import { useState, type FormEvent } from 'react'
import { useAuth } from '../state/AuthContext'
import { ApiError } from '../lib/api'

export function Login() {
  const { login } = useAuth()
  const [email, setEmail] = useState('domingas@quartinhos.com.br')
  const [password, setPassword] = useState('dev')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await login(email, password)
    } catch (err) {
      setError(err instanceof ApiError ? 'Email ou senha inválidos.' : 'Falha ao entrar. Tente novamente.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        background: 'var(--bg)',
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          width: 340,
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius-lg)',
          boxShadow: 'var(--shadow-pop)',
          padding: 28,
        }}
      >
        <div className="logo" style={{ marginBottom: 18 }}>
          Q
        </div>
        <h1 style={{ fontSize: 19, margin: '0 0 4px', letterSpacing: '-0.2px' }}>Entrar</h1>
        <p style={{ margin: '0 0 20px', fontSize: 13, color: 'var(--text-3)' }}>
          Atendimento Quartinhos — ambiente de desenvolvimento
        </p>
        <div className="field">
          <label>Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
        </div>
        <div className="field">
          <label>Senha</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <div style={{ color: 'var(--danger)', fontSize: 12.5, marginBottom: 10 }}>{error}</div>}
        <button className="btn pri" type="submit" disabled={busy} style={{ width: '100%', padding: '9px 0' }}>
          {busy ? 'Entrando…' : 'Entrar'}
        </button>
        <p style={{ marginTop: 16, fontSize: 11.5, color: 'var(--text-3)', lineHeight: 1.5 }}>
          Usuários seedados: domingas@quartinhos.com.br · susi@quartinhos.com.br · daniel@quartinhos.com.br — senha{' '}
          <code>dev</code>
        </p>
      </form>
    </div>
  )
}
